import Api from '@/services/Api';

export default {
  fetchBrandsPromotions(){
    return Api().get(`/4.0/BrandsPromotions`);
  },
}